import React, { useState } from "react";
import { useSelector } from "react-redux";
import { webUrlNode } from "../../../constants/appInfo";


import { useHistory } from "react-router-dom/cjs/react-router-dom";

export default function CreditRechargeButtonNode({ pack }) {


 const history = useHistory();
         const userId = useSelector((state)=>state?.user?.user?.user_id)
  const [loading, setLoading] = useState(false);
const [tenantId,setTenantId] =useState(userId)
const [currentToken,setCurrentToken] =useState(useSelector((state)=>state?.user?.user?.token))
const [appToken,setAppToken] =useState(useSelector((state)=>state?.app?.app?.AppToken))
 

  async function handleCreateOrder() {
  

    if(!userId) { history.push('/login');
      return;}
      
    setLoading(true);

    try {

      // 1️⃣ create recharge order
      const resp = await fetch(
        `${webUrlNode}/api/credits/recharge/create?appToken=${appToken}&currentToken=${currentToken}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${currentToken}`
          },
          body: JSON.stringify({
            packId: pack.id,tenantId:tenantId
          })
        }
      );

      const data = await resp.json();

      if (!resp.ok)
        throw new Error(data?.error || "CREATE_ORDER_FAILED");

      // 2️⃣ load Razorpay sdk
      await loadRazorpayScript();

      // 3️⃣ open checkout
      const options = {
        key: data.razorpayKey || window.RAZORPAY_KEY_ID,
        amount: data.amountPaise,
        currency: data.currency,
        name: "Classmock",
        description: pack.packName,
        order_id: data.orderId,

        handler: async function (response) {

          await verifyPayment(data.rechargeId, response);

        },

        theme: { color: "#2563eb" }
      };

      const rzp = new window.Razorpay(options);
      rzp.open();

    } catch (err) {

      console.error(err);
      
      alert("Payment init failed");

    } finally {
      setLoading(false);
    }
  }


  async function verifyPayment(rechargeId, rzpResponse,) {
console.log({
          rechargeId:rechargeId,tenantId:tenantId,
          razorpayOrderId: rzpResponse.razorpay_order_id,
          razorpayPaymentId: rzpResponse.razorpay_payment_id,
          razorpaySignature: rzpResponse.razorpay_signature
        })
    const resp = await fetch(
      `${webUrlNode}/api/credits/recharge/verify?appToken=${appToken}&currentToken=${currentToken}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${currentToken}`
        },
        body: JSON.stringify({
          rechargeId:rechargeId,
          razorpayOrderId: rzpResponse.razorpay_order_id,
          razorpayPaymentId: rzpResponse.razorpay_payment_id,
          razorpaySignature: rzpResponse.razorpay_signature,tenantId:tenantId
        })
      }
    );

    const data = await resp.json();

    if (!resp.ok) {
      alert(data?.error || "Payment verification failed");
      return;
    }

    alert("Credits added successfully");
  }


  function loadRazorpayScript() {

    return new Promise((resolve, reject) => {

      if (window.Razorpay) return resolve();

      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.onload = resolve;
      script.onerror = () =>
        reject(new Error("Razorpay SDK load failed"));

      document.body.appendChild(script);
    });
  }

  return (
    <button
      onClick={handleCreateOrder}
      disabled={loading}
      style={{
        width: "100%",
        padding: "12px 15px",
        borderRadius: 6,fontSize:"19px",
        border: "none",
        background: "#2563eb",
        color: "#fff",
        cursor: "pointer"
      }}
    >
      {loading ? "Processing..." : `Buy At ₹${pack.amountPaise / 100}`}
    </button>
  );
}
